import { render, staticRenderFns } from "./shipped-status-form.component.vue?vue&type=template&id=7a180290&"
import script from "./shipped-status-form.component.vue?vue&type=script&lang=ts&"
export * from "./shipped-status-form.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports